import React from 'react';
import { Badge } from 'primereact/badge';
import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';
import { WorkflowExecution } from '../types';

interface WorkflowStatusBadgeProps {
  activeWorkflows: WorkflowExecution[];
  onNavigateToWorkflow?: (projectId: string) => void;
}

const WorkflowStatusBadge: React.FC<WorkflowStatusBadgeProps> = ({
  activeWorkflows,
  onNavigateToWorkflow
}) => {
  const op = React.useRef<OverlayPanel>(null);
  const runningCount = activeWorkflows.filter(w => w.status === 'RUNNING').length;

  if (runningCount === 0) return null;

  return (
    <div style={{ position: 'relative' }}>
      <Button
        icon="pi pi-spin pi-spinner"
        rounded
        text
        severity="info"
        onClick={(e) => op.current?.toggle(e)}
        tooltip={`${runningCount} workflow${runningCount > 1 ? 's' : ''} running`}
        tooltipOptions={{ position: 'bottom' }}
      >
        <Badge value={runningCount} severity="info" style={{ position: 'absolute', top: '0', right: '0' }} />
      </Button>

      <OverlayPanel ref={op} style={{ width: '350px' }}>
        <div>
          <h4 style={{ margin: '0 0 1rem 0', fontSize: '1rem', color: '#1f2937' }}>
            Active Workflows ({runningCount})
          </h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            {activeWorkflows
              .filter(w => w.status === 'RUNNING')
              .map((workflow, index) => (
                <div
                  key={index}
                  style={{
                    padding: '0.75rem',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '6px',
                    border: '1px solid #e5e7eb',
                    cursor: 'pointer'
                  }}
                  onClick={() => {
                    // Extract project ID from workflow execution name or ARN
                    // This is a simplified version - you may need to adjust based on your data structure
                    const projectId = workflow.execution_name?.split('-')[0] || '';
                    if (onNavigateToWorkflow && projectId) {
                      onNavigateToWorkflow(projectId);
                      op.current?.hide();
                    }
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                    <i className="pi pi-spin pi-spinner" style={{ color: '#3B82F6', fontSize: '0.875rem' }}></i>
                    <span style={{ fontSize: '0.875rem', fontWeight: 500, color: '#1f2937' }}>
                      {workflow.execution_name || 'Workflow'}
                    </span>
                  </div>
                  <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>
                    {workflow.current_step && `Step: ${workflow.current_step}`}
                  </div>
                  <div style={{ fontSize: '0.75rem', color: '#9ca3af', marginTop: '0.25rem' }}>
                    Started: {new Date(workflow.started_at).toLocaleTimeString()}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </OverlayPanel>
    </div>
  );
};

export default WorkflowStatusBadge;
